"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = isFunction;

function isFunction(x) {
  return typeof x === 'function';
}